import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatPseudoCheckboxModule } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { Router } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import {
  ICTema,
  IPermisos,
  IUsuario,
  IUsuarioEdit,
} from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { UsuariosService } from "../../../services/catalogos/usuarios/usuarios.service";
import { TemasService } from "../../../services/temas/temas.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import { selectCatalogoUsuuarioStatus } from "../../../states/admon-catalogos/selector";
import { selectUsuario } from "../../../states/usuario/selector";
import { emailPatternValidator, nombreUsuario } from "../../utils";
import { AddUsuarioComponent } from "../add-usuario/add-usuario.component";
import { CAT_ACCIONES, CAT_PERMISOS, CAT_ROLES } from "../add-usuario/fixtures";

@Component({
  selector: "app-list-usuarios",
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    AddUsuarioComponent,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatListModule,
    MatPseudoCheckboxModule,
    MatSelectModule,
    MatChipsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatCheckboxModule,
  ],
  templateUrl: "./list-usuarios.component.html",
  styleUrl: "./list-usuarios.component.css",
})
export class ListUsuariosComponent {
  private store: Store<AppState> = inject(Store);
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  router = inject(Router);
  admonCatUsuariosStatus$ = this.store.pipe(
    select(selectCatalogoUsuuarioStatus)
  );

  catRoles = CAT_ROLES;
  catAcciones = CAT_ACCIONES;
  catTemas: ICTema[] = [];
  catTemasState: ICTema[] = [];
  permisosSeleccionados: IPermisos[] = [];
  permisosInitState: IPermisos[] = [];

  usuarios: IUsuario[] = [];
  currentUser!: IUsuario;
  registroSeleccionado!: IUsuario | null;
  ocultarVistaLectura = false;
  editandoRegistro = false;
  mostrarBotones = true;
  editarForm!: FormGroup;

  public user$!: Observable<any>;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private usuariosService: UsuariosService,
    public temasService: TemasService,
    public loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.user$ = this.store.pipe(select(selectUsuario));

    this.loadUsers();

    this.loadingService.show();
    this.admonCatUsuariosStatus$.subscribe((data) => {
      if (data && data.guardando) {
        this.init();
      }
    });

    this.init();
    this.reset();
  }

  async editarRegistro(usuario: IUsuario) {
    this.currentUser = usuario;
    this.mostrarBotones = true;
    this.registroSeleccionado = usuario;
    this.editandoRegistro = true;
    this.editarForm.setValue({
      nombre: usuario?.nombre || "",
      mail: usuario?.mail || "",
      rol: usuario?.rol || "",
      formaEnvio: usuario?.formaEnvio || false,
      tema: "",
      accion: "",
      notificacion: false,
    });

    const user = structuredClone(this.stateUser.state().usuario);

    console.log("usuario", usuario);
    console.log("this.editarForm", this.editarForm.value);
    console.log(" this.catTemas", this.catTemas);

    this.setPermisos(usuario, this.catTemas);
    const userTemaKeys = Object.keys(usuario.temas);

    console.log("userTemaKeys", userTemaKeys);

    this.catTemas = await this.catTemas.filter((tema: any) => {
      return !userTemaKeys.includes(tema?.id);
    });

    console.log(" this.catTema", this.catTemas);
    // Deshabilitar los controles si el rol no es 'admin'
    if (user?.rol !== 4) {
      this.editarForm.get("nombre")?.disable();
      this.editarForm.get("mail")?.disable();
    }

    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "usuarios",
        mostrarEditar: true,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  cancelarEdicion() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "usuarios",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );

    this.editandoRegistro = false;
    this.init();
    this.reset();
  }
  eliminarUsuario(usuario: IUsuario) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "550px",
      data: {
        title: "Borrar usuario",
        message: `Favor de confirmar la eliminación del usuario ${usuario.nombre}`,
        showButtons: {
          accept: true,
          cancel: true,
        },
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
        direction: "end",
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      this.loadingService.show();
      console.log("Acción confirmada");
      this.usuariosService.eliminarUsuario(usuario.id).subscribe((data) => {
        console.log("data", data);
        if (data.exito) {
          this.init();
        } else if (data.error) {
          console.log("data", data.message.message);
          console.log("data", data.message.title);

          this.eliminarError(data.message.title, data.message.message);
        }
      });
    });

    dialogRef.componentInstance.cancelAction.subscribe(() => {});
  }

  ocultarBotones(value: boolean) {
    console.log("value ", value);

    this.mostrarBotones = value;
    this.editandoRegistro = value;
    this.registroSeleccionado = null;
  }

  guardarCambios(data: IUsuario) {
    this.loadingService.show();

    const temas = this.permisosSeleccionados.map((tema: any) => {
      return {
        tId: tema.temaId,
        tema: tema.descripcionTema,
        accion: tema.accionId,
        notificacion: tema.notificacion,
      };
    });

    const payload: IUsuarioEdit = {
      usuario: {
        uid: data.id,
        nombre: this.editarForm.value.nombre,
        email: data.mail,
        rol: this.editarForm.value.rol,
        formaEnvio: this.editarForm.value.formaEnvio,
        permisos: temas,
      },
    };

    console.log("payload", payload);

    if (!this.validateFilds() && this.permisosSeleccionados.length > 0) {
      this.updateUseOrRol(payload);
    } else if (
      !this.validateFilds() &&
      this.permisosSeleccionados.length == 0
    ) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: "450px",
        data: {
          title: "Datos incompletos",
          message: "Favor de capturar al menos un permiso.",
          showButtons: {
            accept: true,
            cancel: false,
          },
          buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
          direction: "end",
        },
      });
      this.loadingService.hide();
    }
  }

  eliminarError(title: string, message: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "1000px",
      maxWidth: "1000px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
        direction: "end",
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {});

    dialogRef.componentInstance.cancelAction.subscribe(() => {});
    this.loadingService.hide();
  }
  eliminarEmpresa(usuario: IUsuario): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title: "Confirmación",
        message: "¿Estás seguro de que deseas eliminar este elemento?",
        showButtons: {
          accept: true,
          cancel: true,
        },
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
        direction: "end",
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      this.usuariosService.eliminarUsuario(usuario.id);
    });

    dialogRef.componentInstance.cancelAction.subscribe(() => {});
  }

  mostrarOcultar(event: any, usuario: IUsuario) {
    console.log("event", event.checked);
    console.log("usuario", usuario);

    this.loadingService.show();
    this.usuariosService
      .actualizarMostar({ uid: usuario.id, mostrar: event.checked })
      .subscribe((data) => {
        if (!data.error) {
          // alert("!data.error");
          setTimeout(() => {
            this.init();
          }, 2000);
        }
      });
  }

  nuevoPermiso() {
    if (!this.editarForm.value.tema || !this.editarForm.value.accion) {
      this.validarPermiso();
      return;
    }

    const findTema = this.catTemasState.find(
      (cat) =>
        cat.descripcion.toLowerCase() ===
        this.editarForm.value.tema.descripcion.toLowerCase()
    );
    const user = structuredClone(this.stateUser.state().usuario);
    console.log("findTema", findTema);
    console.log("this.editarForm.value.tema.id", this.editarForm.value);

    console.log("this.editarForm.value.tema.id", this.editarForm.value.tema.id);

    const newPermiso: IPermisos = {
      temaId: findTema?.id ?? "",
      accionId: this.editarForm.value.accion.accion,
      descripcionTema: this.editarForm.value.tema.descripcion,
      descChip: `${this.editarForm.value.tema.descripcion} - ${
        this.editarForm.value.accion.label
      } ${this.editarForm.value.notificacion ? " - Notifi..." : ""}`,
      notificacion: this.editarForm.value.notificacion,
    };
    this.permisosSeleccionados.push(newPermiso);
    console.log("permisosSeleccionados", this.permisosSeleccionados);

    this.catTemas = this.catTemas.filter(
      (cat) => cat.descripcion !== this.editarForm.value.tema.descripcion
    );
    this.clearCombos();
  }

  removePermiso(permiso: IPermisos) {
    this.permisosSeleccionados = this.permisosSeleccionados.filter(
      (select) => select.temaId !== permiso.temaId
    );

    const permisoToAdd = CAT_PERMISOS.find(
      (r) => r.descripcion === permiso.descripcionTema
    );
    if (permisoToAdd) {
      this.catTemas.push(permisoToAdd);
    }
    this.clearCombos();
  }

  clearCombos() {
    this.editarForm.patchValue({
      tema: "",
      accion: "",
      notificacion: "",
    });
  }

  validarPermiso(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title: "Datos incompletos",
        message: "Favor de capturar tema y acción.",
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {});

    dialogRef.componentInstance.cancelAction.subscribe(() => {});
  }

  validateFilds() {
    const editarForm = this.editarForm.getRawValue();
    if (editarForm.nombre && editarForm.nombre != "" && editarForm.rol) {
      return false;
    }
    return true;
  }

  setPermisos(usuario: IUsuario, catTemas: ICTema[]) {
    if (usuario && Object.keys(usuario.temas).length > 0) {
      Object.keys(usuario.temas).forEach((tema: any) => {
        const findTema = catTemas.find((cat) => cat.id === tema);
        const findAccion = this.catAcciones.find(
          (cat) => cat.accion === usuario.temas[tema].permiso
        );
        if (findTema && findAccion) {
          const newPermiso: IPermisos = {
            temaId: tema,
            accionId: usuario.temas[tema].permiso,
            descripcionTema: findTema?.descripcion || "",
            descChip: `${findTema?.descripcion} - ${findAccion?.label} ${
              usuario.temas[tema].notificacion ? " - Notifi..." : ""
            }`,
            notificacion: usuario.temas[tema].notificacion,
          };
          this.permisosSeleccionados.push(newPermiso);
        }
      });

      this.permisosInitState = this.permisosSeleccionados;
    }
  }

  init() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "usuarios",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
    this.temasService.cargarTemas().subscribe((temas) => {
      this.catTemas = temas;
      this.catTemasState = temas;
    });
    this.reset();
    this.loadUsers();
  }

  reset() {
    this.editarForm = this.fb.group({
      nombre: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(75),
          nombreUsuario(),
        ],
      ],
      mail: [
        { value: "", disabled: true },
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(150),
          emailPatternValidator(),
        ],
      ],

      rol: ["", [Validators.required]],
      formaEnvio: [false, [Validators.required]],
      tema: ["", [Validators.required]],
      accion: ["", [Validators.required]],
      notificacion: [false, [Validators.required]],
    });
    this.catRoles = CAT_ROLES;
    this.catAcciones = CAT_ACCIONES;
    this.catTemas = [];
    this.permisosSeleccionados = [];
    this.loadingService.hide();
  }

  logOut(data: any) {
    const user = structuredClone(this.stateUser.state().usuario);

    console.log("logOut data", data);
    console.log("logOut user", user);

    if (
      user &&
      data &&
      data.usuario &&
      user.uid === data.usuario.uid &&
      user.rol !== data.usuario.rol
    ) {
      this.router.navigate([`/login`]);
      return;
    }
    this.init();
  }

  loadUsers() {
    this.usuariosService.cargarUsuarios().subscribe(
      (response) => {
        this.loadingService.hide();
        this.usuarios = response;

        console.log("usuarios cargadas:", this.usuarios);
      },
      (error) => {}
    );
  }
  updateUseOrRol(payload: IUsuarioEdit) {
    const user = structuredClone(this.stateUser.state().usuario);

    if (user && user.rol === 4) {
      this.usuariosService.editarUsuario(payload).subscribe((data) => {
        console.log("data lll", data);
        if (data.exito) {
          this.loadingService.hide();
          this.logOut(payload);
          this.store.dispatch(
            showHideCatalogo({
              tipoCatalogo: "usuarios",
              mostrarEditar: false,
              mostrarNuevo: false,
              guardando: false,
            })
          );
        } else if (data.message && data.message.code == "403") {
          this.permisosSeleccionados = this.permisosInitState;

          const ids = this.permisosInitState.map((permiso) => permiso.temaId);

          console.log("ids", ids);

          this.catTemas = this.catTemasState.filter((tema: any) => {
            return !ids.includes(tema?.id);
          });

          this.editarRegistro(this.currentUser);
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: "1000px",
            maxWidth: "1000px",
            data: {
              title: data.message.title,
              message: data.message.message,
              showButtons: {
                accept: true,
                cancel: false,
              },
              buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
              direction: "end",
            },
          });
          this.loadingService.hide();
        } else {
          this.store.dispatch(
            showHideCatalogo({
              tipoCatalogo: "usuarios",
              mostrarEditar: false,
              mostrarNuevo: false,
              guardando: false,
            })
          );
          this.loadingService.hide();
        }
      });
    } else {
      const rol = payload.usuario.rol.toString();
      const uid = payload.usuario.uid;
      this.usuariosService.updateRol(rol, uid).subscribe((updatedRol) => {
        console.log("updatedRol", updatedRol);
      });
    }
  }
}
